import { Config } from "../../Config";
const fetchGoogleTagManagerId = (brandName) => {
    const result = fetch(`${Config.epiBaseUrl}googletagmanager/gtmid?brandName=${brandName}`, {
        method: "get",
        headers: new Headers({ "content-type": "application/json" }),
    })
        .then((response) => {
        return response.json();
    })
        .then((result) => {
        return result;
    });
    return result;
};
export default fetchGoogleTagManagerId;
